export interface Comune {
  comune: string;
  zonaId: number;
}

export const comuniData: Comune[] = [
  { comune: "ACERNO", zonaId: 5 },
  { comune: "ACERRA", zonaId: 1 },
  { comune: "AFRAGOLA", zonaId: 1 },
  { comune: "AGEROLA", zonaId: 3 },
  { comune: "AGROPOLI", zonaId: 6 },
  { comune: "AIELLO DEL SABATO", zonaId: 3 },
  { comune: "AILANO", zonaId: 2 },
  { comune: "AIROLA", zonaId: 2 },
  { comune: "ALBANELLA", zonaId: 6 },
  { comune: "ALFANO", zonaId: 8 },
  { comune: "ALIFE", zonaId: 2 },
  { comune: "ALTAVILLA IRPINA", zonaId: 4 },
  { comune: "ALTAVILLA SILENTINA", zonaId: 6 },
  { comune: "ALVIGNANO", zonaId: 2 },
  { comune: "AMALFI", zonaId: 3 },
  { comune: "AMOROSI", zonaId: 2 },
  { comune: "ANACAPRI", zonaId: 1 },
  { comune: "ANDRETTA", zonaId: 4 },
  { comune: "ANGRI", zonaId: 3 },
  { comune: "APICE", zonaId: 4 },
  { comune: "APOLLOSA", zonaId: 4 },
  { comune: "AQUARA", zonaId: 6 },
  { comune: "AQUILONIA", zonaId: 4 },
  { comune: "ARIANO IRPINO", zonaId: 4 },
  { comune: "ARIENZO", zonaId: 3 },
  { comune: "ARPAIA", zonaId: 3 },
  { comune: "ARPAISE", zonaId: 4 },
  { comune: "ARZANO", zonaId: 1 },
  { comune: "ASCEA", zonaId: 6 },
  { comune: "ATENA LUCANA", zonaId: 7 },
  { comune: "ATRANI", zonaId: 3 },
  { comune: "ATRIPALDA", zonaId: 4 },
  { comune: "AULETTA", zonaId: 7 },
  { comune: "AVELLA", zonaId: 3 },
  { comune: "AVELLINO", zonaId: 3 },
  { comune: "AVERSA", zonaId: 1 },
  { comune: "BACOLI", zonaId: 1 },
  { comune: "BAGNOLI IRPINO", zonaId: 5 },
  { comune: "BAIA E LATINA", zonaId: 2 },
  { comune: "BAIANO", zonaId: 3 },
  { comune: "BARANO D'ISCHIA", zonaId: 1 },
  { comune: "BARONISSI", zonaId: 3 },
  { comune: "BASELICE", zonaId: 4 },
  { comune: "BATTIPAGLIA", zonaId: 5 },
  { comune: "BELLIZZI", zonaId: 5 },
  { comune: "BELLONA", zonaId: 1 },
  { comune: "BELLOSGUARDO", zonaId: 6 },
  { comune: "BENEVENTO", zonaId: 4 },
  { comune: "BISACCIA", zonaId: 4 },
  { comune: "BONEA", zonaId: 2 },
  { comune: "BONITO", zonaId: 4 },
  { comune: "BOSCOREALE", zonaId: 1 },
  { comune: "BOSCOTRECASE", zonaId: 1 },
  { comune: "BRACIGLIANO", zonaId: 3 },
  { comune: "BRUSCIANO", zonaId: 1 },
  { comune: "BUCCIANO", zonaId: 2 },
  { comune: "BUCCINO", zonaId: 7 },
  { comune: "BUONABITACOLO", zonaId: 7 },
  { comune: "BUONALBERGO", zonaId: 4 },
  { comune: "CAGGIANO", zonaId: 7 },
  { comune: "CAIANELLO", zonaId: 2 },
  { comune: "CAIAZZO", zonaId: 2 },
  { comune: "CAIRANO", zonaId: 4 },
  { comune: "CAIVANO", zonaId: 1 },
  { comune: "CALABRITTO", zonaId: 5 },
  { comune: "CALITRI", zonaId: 4 },
  { comune: "CALVANICO", zonaId: 3 },
  { comune: "CALVI", zonaId: 4 },
  { comune: "CALVI RISORTA", zonaId: 1 },
  { comune: "CALVIZZANO", zonaId: 1 },
  { comune: "CAMEROTA", zonaId: 8 },
  { comune: "CAMIGLIANO", zonaId: 1 },
  { comune: "CAMPAGNA", zonaId: 5 },
  { comune: "CAMPOLATTARO", zonaId: 4 },
  { comune: "CAMPOLI DEL MONTE TABURNO", zonaId: 4 },
  { comune: "CAMPORA", zonaId: 6 },
  { comune: "CAMPOSANO", zonaId: 1 },
  { comune: "CANCELLO ED ARNONE", zonaId: 1 },
  { comune: "CANDIDA", zonaId: 4 },
  { comune: "CANNALONGA", zonaId: 6 },
  { comune: "CAPACCIO", zonaId: 6 },
  { comune: "CAPODRISE", zonaId: 1 },
  { comune: "CAPOSELE", zonaId: 5 },
  { comune: "CAPRI", zonaId: 1 },
  { comune: "CAPRIATI A VOLTURNO", zonaId: 2 },
  { comune: "CAPRIGLIA IRPINA", zonaId: 3 },
  { comune: "CAPUA", zonaId: 1 },
  { comune: "CARBONARA DI NOLA", zonaId: 3 },
  { comune: "CARDITO", zonaId: 1 },
  { comune: "CARIFE", zonaId: 4 },
  { comune: "CARINARO", zonaId: 1 },
  { comune: "CARINOLA", zonaId: 1 },
  { comune: "CASAGIOVE", zonaId: 1 },
  { comune: "CASAL DI PRINCIPE", zonaId: 1 },
  { comune: "CASAL VELINO", zonaId: 6 },
  { comune: "CASALBORE", zonaId: 4 },
  { comune: "CASALBUONO", zonaId: 7 },
  { comune: "CASALDUNI", zonaId: 4 },
  { comune: "CASALETTO SPARTANO", zonaId: 8 },
  { comune: "CASALNUOVO DI NAPOLI", zonaId: 1 },
  { comune: "CASALUCE", zonaId: 1 },
  { comune: "CASAMARCIANO", zonaId: 3 },
  { comune: "CASAMICCIOLA TERME", zonaId: 1 },
  { comune: "CASANDRINO", zonaId: 1 },
  { comune: "CASAPESENNA", zonaId: 1 },
  { comune: "CASAPULLA", zonaId: 1 },
  { comune: "CASAVATORE", zonaId: 1 },
  { comune: "CASELLE IN PITTARI", zonaId: 8 },
  { comune: "CASERTA", zonaId: 2 },
  { comune: "CASOLA DI NAPOLI", zonaId: 3 },
  { comune: "CASORIA", zonaId: 1 },
  { comune: "CASSANO IRPINO", zonaId: 5 },
  { comune: "CASTEL BARONIA", zonaId: 4 },
  { comune: "CASTEL CAMPAGNANO", zonaId: 2 },
  { comune: "CASTEL DI SASSO", zonaId: 2 },
  { comune: "CASTEL MORRONE", zonaId: 2 },
  { comune: "CASTEL SAN GIORGIO", zonaId: 3 },
  { comune: "CASTEL SAN LORENZO", zonaId: 6 },
  { comune: "CASTEL VOLTURNO", zonaId: 1 },
  { comune: "CASTELCIVITA", zonaId: 6 },
  { comune: "CASTELFRANCI", zonaId: 4 },
  { comune: "CASTELFRANCO IN MISCANO", zonaId: 4 },
  { comune: "CASTELLABATE", zonaId: 6 },
  { comune: "CASTELLAMMARE DI STABIA", zonaId: 3 },
  { comune: "CASTELLO DEL MATESE", zonaId: 2 },
  { comune: "CASTELLO DI CISTERNA", zonaId: 1 },
  { comune: "CASTELNUOVO CILENTO", zonaId: 6 },
  { comune: "CASTELNUOVO DI CONZA", zonaId: 5 },
  { comune: "CASTELPAGANO", zonaId: 4 },
  { comune: "CASTELPOTO", zonaId: 4 },
  { comune: "CASTELVENERE", zonaId: 2 },
  { comune: "CASTELVETERE IN VAL FORTORE", zonaId: 4 },
  { comune: "CASTELVETERE SUL CALORE", zonaId: 3 },
  { comune: "CASTIGLIONE DEL GENOVESI", zonaId: 3 },
  { comune: "CAUTANO", zonaId: 2 },
  { comune: "CAVA DE' TIRRENI", zonaId: 3 },
  { comune: "CELLE DI BULGHERIA", zonaId: 8 },
  { comune: "CELLOLE", zonaId: 1 },
  { comune: "CENTOLA", zonaId: 8 },
  { comune: "CEPPALONI", zonaId: 4 },
  { comune: "CERASO", zonaId: 6 },
  { comune: "CERCOLA", zonaId: 1 },
  { comune: "CERRETO SANNITA", zonaId: 2 },
  { comune: "CERVINARA", zonaId: 3 },
  { comune: "CERVINO", zonaId: 2 },
  { comune: "CESA", zonaId: 1 },
  { comune: "CESINALI", zonaId: 4 },
  { comune: "CETARA", zonaId: 3 },
  { comune: "CHIANCHE", zonaId: 4 },
  { comune: "CHIUSANO DI SAN DOMENICO", zonaId: 3 },
  { comune: "CICCIANO", zonaId: 3 },
  { comune: "CICERALE", zonaId: 6 },
  { comune: "CIMITILE", zonaId: 1 },
  { comune: "CIORLANO", zonaId: 2 },
  { comune: "CIRCELLO", zonaId: 4 },
  { comune: "COLLE SANNITA", zonaId: 4 },
  { comune: "COLLIANO", zonaId: 5 },
  { comune: "COMIZIANO", zonaId: 3 },
  { comune: "CONCA DEI MARINI", zonaId: 3 },
  { comune: "CONCA DELLA CAMPANIA", zonaId: 2 },
  { comune: "CONTRADA", zonaId: 3 },
  { comune: "CONTRONE", zonaId: 6 },
  { comune: "CONTURSI TERME", zonaId: 5 },
  { comune: "CONZA DELLA CAMPANIA", zonaId: 4 },
  { comune: "CORBARA", zonaId: 3 },
  { comune: "CORLETO MONFORTE", zonaId: 6 },
  { comune: "CRISPANO", zonaId: 1 },
  { comune: "CUCCARO VETERE", zonaId: 8 },
  { comune: "CURTI", zonaId: 1 },
  { comune: "CUSANO MUTRI", zonaId: 2 },
  { comune: "DOMICELLA", zonaId: 3 },
  { comune: "DRAGONI", zonaId: 2 },
  { comune: "DUGENTA", zonaId: 2 },
  { comune: "DURAZZANO", zonaId: 2 },
  { comune: "EBOLI", zonaId: 6 },
  { comune: "ERCOLANO", zonaId: 1 },
  { comune: "FAICCHIO", zonaId: 2 },
  { comune: "FALCIANO DEL MASSICO", zonaId: 1 },
  { comune: "FELITTO", zonaId: 6 },
  { comune: "FISCIANO", zonaId: 3 },
  { comune: "FLUMERI", zonaId: 4 },
  { comune: "FOGLIANISE", zonaId: 4 },
  { comune: "FOIANO DI VAL FORTORE", zonaId: 4 },
  { comune: "FONTANAROSA", zonaId: 4 },
  { comune: "FONTEGRECA", zonaId: 2 },
  { comune: "FORCHIA", zonaId: 3 },
  { comune: "FORINO", zonaId: 3 },
  { comune: "FORIO", zonaId: 1 },
  { comune: "FORMICOLA", zonaId: 2 },
  { comune: "FRAGNETO L'ABATE", zonaId: 4 },
  { comune: "FRAGNETO MONFORTE", zonaId: 4 },
  { comune: "FRANCOLISE", zonaId: 1 },
  { comune: "FRASSO TELESINO", zonaId: 2 },
  { comune: "FRATTAMAGGIORE", zonaId: 1 },
  { comune: "FRATTAMINORE", zonaId: 1 },
  { comune: "FRIGENTO", zonaId: 4 },
  { comune: "FRIGNANO", zonaId: 1 },
  { comune: "FURORE", zonaId: 3 },
  { comune: "FUTANI", zonaId: 8 },
  { comune: "GALLO MATESE", zonaId: 2 },
  { comune: "GALLUCCIO", zonaId: 2 },
  { comune: "GESUALDO", zonaId: 4 },
  { comune: "GIANO VETUSTO", zonaId: 1 },
  { comune: "GIFFONI SEI CASALI", zonaId: 3 },
  { comune: "GIFFONI VALLE PIANA", zonaId: 3 },
  { comune: "GINESTRA DEGLI SCHIAVONI", zonaId: 4 },
  { comune: "GIOI", zonaId: 6 },
  { comune: "GIOIA SANNITICA", zonaId: 2 },
  { comune: "GIUGLIANO IN CAMPANIA", zonaId: 1 },
  { comune: "GIUNGANO", zonaId: 6 },
  { comune: "GRAGNANO", zonaId: 3 },
  { comune: "GRAZZANISE", zonaId: 1 },
  { comune: "GRECI", zonaId: 4 },
  { comune: "GRICIGNANO DI AVERSA", zonaId: 1 },
  { comune: "GROTTAMINARDA", zonaId: 4 },
  { comune: "GROTTOLELLA", zonaId: 4 },
  { comune: "GRUMO NEVANO", zonaId: 1 },
  { comune: "GUARDIA LOMBARDI", zonaId: 4 },
  { comune: "GUARDIA SANFRAMONDI", zonaId: 2 },
  { comune: "ISCHIA", zonaId: 1 },
  { comune: "ISPANI", zonaId: 8 },
  { comune: "LACCO AMENO", zonaId: 1 },
  { comune: "LACEDONIA", zonaId: 4 },
  { comune: "LAPIO", zonaId: 4 },
  { comune: "LAUREANA CILENTO", zonaId: 6 },
  { comune: "LAURINO", zonaId: 6 },
  { comune: "LAURITO", zonaId: 8 },
  { comune: "LAURO", zonaId: 3 },
  { comune: "LAVIANO", zonaId: 5 },
  { comune: "LETINO", zonaId: 2 },
  { comune: "LETTERE", zonaId: 3 },
  { comune: "LIBERI", zonaId: 2 },
  { comune: "LIMATOLA", zonaId: 2 },
  { comune: "LIONI", zonaId: 5 },
  { comune: "LIVERI", zonaId: 3 },
  { comune: "LUOGOSANO", zonaId: 4 },
  { comune: "LUSCIANO", zonaId: 1 },
  { comune: "LUSTRA", zonaId: 6 },
  { comune: "MACERATA CAMPANIA", zonaId: 1 },
  { comune: "MADDALONI", zonaId: 1 },
  { comune: "MAGLIANO VETERE", zonaId: 6 },
  { comune: "MAIORI", zonaId: 3 },
  { comune: "MANOCALZATI", zonaId: 4 },
  { comune: "MARANO DI NAPOLI", zonaId: 1 },
  { comune: "MARCIANISE", zonaId: 1 },
  { comune: "MARIGLIANELLA", zonaId: 1 },
  { comune: "MARIGLIANO", zonaId: 1 },
  { comune: "MARZANO APPIO", zonaId: 2 },
  { comune: "MARZANO DI NOLA", zonaId: 3 },
  { comune: "MASSA DI SOMMA", zonaId: 1 },
  { comune: "MASSA LUBRENSE", zonaId: 3 },
  { comune: "MELITO DI NAPOLI", zonaId: 1 },
  { comune: "MELITO IRPINO", zonaId: 4 },
  { comune: "MELIZZANO", zonaId: 2 },
  { comune: "MERCATO SAN SEVERINO", zonaId: 3 },
  { comune: "MERCOGLIANO", zonaId: 3 },
  { comune: "META", zonaId: 3 },
  { comune: "MIGNANO MONTE LUNGO", zonaId: 2 },
  { comune: "MINORI", zonaId: 3 },
  { comune: "MIRABELLA ECLANO", zonaId: 4 },
  { comune: "MOIANO", zonaId: 2 },
  { comune: "MOIO DELLA CIVITELLA", zonaId: 6 },
  { comune: "MOLINARA", zonaId: 4 },
  { comune: "MONDRAGONE", zonaId: 1 },
  { comune: "MONTAGUTO", zonaId: 4 },
  { comune: "MONTANO ANTILIA", zonaId: 8 },
  { comune: "MONTE DI PROCIDA", zonaId: 1 },
  { comune: "MONTE SAN GIACOMO", zonaId: 7 },
  { comune: "MONTECALVO IRPINO", zonaId: 4 },
  { comune: "MONTECORICE", zonaId: 6 },
  { comune: "MONTECORVINO PUGLIANO", zonaId: 5 },
  { comune: "MONTECORVINO ROVELLA", zonaId: 5 },
  { comune: "MONTEFALCIONE", zonaId: 4 },
  { comune: "MONTEFALCONE DI VAL FORTORE", zonaId: 4 },
  { comune: "MONTEFORTE CILENTO", zonaId: 6 },
  { comune: "MONTEFORTE IRPINO", zonaId: 3 },
  { comune: "MONTEFREDANE", zonaId: 4 },
  { comune: "MONTEFUSCO", zonaId: 4 },
  { comune: "MONTELLA", zonaId: 5 },
  { comune: "MONTEMARANO", zonaId: 3 },
  { comune: "MONTEMILETTO", zonaId: 4 },
  { comune: "MONTESANO SULLA MARCELLANA", zonaId: 7 },
  { comune: "MONTESARCHIO", zonaId: 4 },
  { comune: "MONTEVERDE", zonaId: 4 },
  { comune: "MONTORO", zonaId: 3 },
  { comune: "MORCONE", zonaId: 4 },
  { comune: "MORIGERATI", zonaId: 8 },
  { comune: "MORRA DE SANCTIS", zonaId: 4 },
  { comune: "MOSCHIANO", zonaId: 3 },
  { comune: "MUGNANO DEL CARDINALE", zonaId: 3 },
  { comune: "MUGNANO DI NAPOLI", zonaId: 1 },
  { comune: "NAPOLI", zonaId: 1 },
  { comune: "NOCERA INFERIORE", zonaId: 3 },
  { comune: "NOCERA SUPERIORE", zonaId: 3 },
  { comune: "NOLA", zonaId: 1 },
  { comune: "NOVI VELIA", zonaId: 6 },
  { comune: "NUSCO", zonaId: 5 },
  { comune: "OGLIASTRO CILENTO", zonaId: 6 },
  { comune: "OLEVANO SUL TUSCIANO", zonaId: 5 },
  { comune: "OLIVETO CITRA", zonaId: 5 },
  { comune: "OMIGNANO", zonaId: 6 },
  { comune: "ORRIA", zonaId: 6 },
  { comune: "ORTA DI ATELLA", zonaId: 1 },
  { comune: "OSPEDALETTO D'ALPINOLO", zonaId: 3 },
  { comune: "OTTATI", zonaId: 6 },
  { comune: "OTTAVIANO", zonaId: 1 },
  { comune: "PADULA", zonaId: 7 },
  { comune: "PADULI", zonaId: 4 },
  { comune: "PAGANI", zonaId: 3 },
  { comune: "PAGO DEL VALLO DI LAURO", zonaId: 3 },
  { comune: "PAGO VEIANO", zonaId: 4 },
  { comune: "PALMA CAMPANIA", zonaId: 3 },
  { comune: "PALOMONTE", zonaId: 7 },
  { comune: "PANNARANO", zonaId: 3 },
  { comune: "PAOLISI", zonaId: 3 },
  { comune: "PARETE", zonaId: 1 },
  { comune: "PAROLISE", zonaId: 4 },
  { comune: "PASTORANO", zonaId: 1 },
  { comune: "PATERNOPOLI", zonaId: 4 },
  { comune: "PAUPISI", zonaId: 4 },
  { comune: "PELLEZZANO", zonaId: 3 },
  { comune: "PERDIFUMO", zonaId: 6 },
  { comune: "PERITO", zonaId: 6 },
  { comune: "PERTOSA", zonaId: 7 },
  { comune: "PESCO SANNITA", zonaId: 4 },
  { comune: "PETINA", zonaId: 7 },
  { comune: "PETRURO IRPINO", zonaId: 4 },
  { comune: "PIAGGINE", zonaId: 6 },
  { comune: "PIANA DI MONTE VERNA", zonaId: 2 },
  { comune: "PIANO DI SORRENTO", zonaId: 3 },
  { comune: "PIEDIMONTE MATESE", zonaId: 2 },
  { comune: "PIETRADEFUSI", zonaId: 4 },
  { comune: "PIETRAMELARA", zonaId: 2 },
  { comune: "PIETRAROJA", zonaId: 2 },
  { comune: "PIETRASTORNINA", zonaId: 3 },
  { comune: "PIETRAVAIRANO", zonaId: 2 },
  { comune: "PIETRELCINA", zonaId: 4 },
  { comune: "PIGNATARO MAGGIORE", zonaId: 1 },
  { comune: "PIMONTE", zonaId: 3 },
  { comune: "PISCIOTTA", zonaId: 6 },
  { comune: "POGGIOMARINO", zonaId: 1 },
  { comune: "POLLA", zonaId: 7 },
  { comune: "POLLENA TROCCHIA", zonaId: 1 },
  { comune: "POLLICA", zonaId: 6 },
  { comune: "POMIGLIANO D'ARCO", zonaId: 1 },
  { comune: "POMPEI", zonaId: 3 },
  { comune: "PONTE", zonaId: 4 },
  { comune: "PONTECAGNANO FAIANO", zonaId: 5 },
  { comune: "PONTELANDOLFO", zonaId: 4 },
  { comune: "PONTELATONE", zonaId: 2 },
  { comune: "PORTICI", zonaId: 1 },
  { comune: "PORTICO DI CASERTA", zonaId: 1 },
  { comune: "POSITANO", zonaId: 3 },
  { comune: "POSTIGLIONE", zonaId: 6 },
  { comune: "POZZUOLI", zonaId: 1 },
  { comune: "PRAIANO", zonaId: 3 },
  { comune: "PRATA DI PRINCIPATO ULTRA", zonaId: 4 },
  { comune: "PRATA SANNITA", zonaId: 2 },
  { comune: "PRATELLA", zonaId: 2 },
  { comune: "PRATOLA SERRA", zonaId: 4 },
  { comune: "PRESENZANO", zonaId: 2 },
  { comune: "PRIGNANO CILENTO", zonaId: 6 },
  { comune: "PROCIDA", zonaId: 1 },
  { comune: "PUGLIANELLO", zonaId: 2 },
  { comune: "QUADRELLE", zonaId: 3 },
  { comune: "QUALIANO", zonaId: 1 },
  { comune: "QUARTO", zonaId: 1 },
  { comune: "QUINDICI", zonaId: 3 },
  { comune: "RAVELLO", zonaId: 3 },
  { comune: "RAVISCANINA", zonaId: 2 },
  { comune: "RECALE", zonaId: 1 },
  { comune: "REINO", zonaId: 4 },
  { comune: "RIARDO", zonaId: 2 },
  { comune: "RICIGLIANO", zonaId: 7 },
  { comune: "ROCCA D'EVANDRO", zonaId: 2 },
  { comune: "ROCCA SAN FELICE", zonaId: 4 },
  { comune: "ROCCABASCERANA", zonaId: 4 },
  { comune: "ROCCADASPIDE", zonaId: 6 },
  { comune: "ROCCAGLORIOSA", zonaId: 8 },
  { comune: "ROCCAMONFINA", zonaId: 2 },
  { comune: "ROCCAPIEMONTE", zonaId: 3 },
  { comune: "ROCCARAINOLA", zonaId: 3 },
  { comune: "ROCCAROMANA", zonaId: 2 },
  { comune: "ROCCHETTA E CROCE", zonaId: 1 },
  { comune: "ROFRANO", zonaId: 8 },
  { comune: "ROMAGNANO AL MONTE", zonaId: 7 },
  { comune: "ROSCIGNO", zonaId: 6 },
  { comune: "ROTONDI", zonaId: 3 },
  { comune: "RUTINO", zonaId: 6 },
  { comune: "RUVIANO", zonaId: 2 },
  { comune: "SACCO", zonaId: 6 },
  { comune: "SALA CONSILINA", zonaId: 7 },
  { comune: "SALENTO", zonaId: 6 },
  { comune: "SALERNO", zonaId: 3 },
  { comune: "SALVITELLE", zonaId: 7 },
  { comune: "SALZA IRPINA", zonaId: 3 },
  { comune: "SAN BARTOLOMEO IN GALDO", zonaId: 4 },
  { comune: "SAN CIPRIANO D'AVERSA", zonaId: 1 },
  { comune: "SAN CIPRIANO PICENTINO", zonaId: 3 },
  { comune: "SAN FELICE A CANCELLO", zonaId: 3 },
  { comune: "SAN GENNARO VESUVIANO", zonaId: 1 },
  { comune: "SAN GIORGIO A CREMANO", zonaId: 1 },
  { comune: "SAN GIORGIO DEL SANNIO", zonaId: 4 },
  { comune: "SAN GIORGIO LA MOLARA", zonaId: 4 },
  { comune: "SAN GIOVANNI A PIRO", zonaId: 8 },
  { comune: "SAN GIUSEPPE VESUVIANO", zonaId: 1 },
  { comune: "SAN GREGORIO MAGNO", zonaId: 7 },
  { comune: "SAN GREGORIO MATESE", zonaId: 2 },
  { comune: "SAN LEUCIO DEL SANNIO", zonaId: 4 },
  { comune: "SAN LORENZELLO", zonaId: 2 },
  { comune: "SAN LORENZO MAGGIORE", zonaId: 4 },
  { comune: "SAN LUPO", zonaId: 4 },
  { comune: "SAN MANGO PIEMONTE", zonaId: 3 },
  { comune: "SAN MANGO SUL CALORE", zonaId: 4 },
  { comune: "SAN MARCELLINO", zonaId: 1 },
  { comune: "SAN MARCO DEI CAVOTI", zonaId: 4 },
  { comune: "SAN MARCO EVANGELISTA", zonaId: 1 },
  { comune: "SAN MARTINO SANNITA", zonaId: 4 },
  { comune: "SAN MARTINO VALLE CAUDINA", zonaId: 3 },
  { comune: "SAN MARZANO SUL SARNO", zonaId: 3 },
  { comune: "SAN MAURO CILENTO", zonaId: 6 },
  { comune: "SAN MAURO LA BRUCA", zonaId: 8 },
  { comune: "SAN MICHELE DI SERINO", zonaId: 3 },
  { comune: "SAN NAZZARO", zonaId: 4 },
  { comune: "SAN NICOLA BARONIA", zonaId: 4 },
  { comune: "SAN NICOLA LA STRADA", zonaId: 1 },
  { comune: "SAN NICOLA MANFREDI", zonaId: 4 },
  { comune: "SAN PAOLO BEL SITO", zonaId: 1 },
  { comune: "SAN PIETRO AL TANAGRO", zonaId: 7 },
  { comune: "SAN PIETRO INFINE", zonaId: 2 },
  { comune: "SAN POTITO SANNITICO", zonaId: 2 },
  { comune: "SAN POTITO ULTRA", zonaId: 4 },
  { comune: "SAN PRISCO", zonaId: 1 },
  { comune: "SAN RUFO", zonaId: 7 },
  { comune: "SAN SALVATORE TELESINO", zonaId: 2 },
  { comune: "SAN SEBASTIANO AL VESUVIO", zonaId: 1 },
  { comune: "SAN SOSSIO BARONIA", zonaId: 4 },
  { comune: "SAN TAMMARO", zonaId: 1 },
  { comune: "SAN VALENTINO TORIO", zonaId: 3 },
  { comune: "SAN VITALIANO", zonaId: 1 },
  { comune: "SANT'AGATA DE' GOTI", zonaId: 2 },
  { comune: "SANT'AGNELLO", zonaId: 3 },
  { comune: "SANT'ANASTASIA", zonaId: 1 },
  { comune: "SANT'ANDREA DI CONZA", zonaId: 4 },
  { comune: "SANT'ANGELO A CUPOLO", zonaId: 4 },
  { comune: "SANT'ANGELO A FASANELLA", zonaId: 6 },
  { comune: "SANT'ANGELO A SCALA", zonaId: 3 },
  { comune: "SANT'ANGELO ALL'ESCA", zonaId: 4 },
  { comune: "SANT'ANGELO D'ALIFE", zonaId: 2 },
  { comune: "SANT'ANGELO DEI LOMBARDI", zonaId: 4 },
  { comune: "SANT'ANTIMO", zonaId: 1 },
  { comune: "SANT'ANTONIO ABATE", zonaId: 3 },
  { comune: "SANT'ARCANGELO TRIMONTE", zonaId: 4 },
  { comune: "SANT'ARPINO", zonaId: 1 },
  { comune: "SANT'ARSENIO", zonaId: 7 },
  { comune: "SANT'EGIDIO DEL MONTE ALBINO", zonaId: 3 },
  { comune: "SANTA CROCE DEL SANNIO", zonaId: 4 },
  { comune: "SANTA LUCIA DI SERINO", zonaId: 3 },
  { comune: "SANTA MARIA A VICO", zonaId: 2 },
  { comune: "SANTA MARIA CAPUA VETERE", zonaId: 1 },
  { comune: "SANTA MARIA LA CARITA'", zonaId: 3 },
  { comune: "SANTA MARIA LA FOSSA", zonaId: 1 },
  { comune: "SANTA MARINA", zonaId: 8 },
  { comune: "SANTA PAOLINA", zonaId: 4 },
  { comune: "SANTO STEFANO DEL SOLE", zonaId: 3 },
  { comune: "SANTOMENNA", zonaId: 5 },
  { comune: "SANZA", zonaId: 8 },
  { comune: "SAPRI", zonaId: 8 },
  { comune: "SARNO", zonaId: 3 },
  { comune: "SASSANO", zonaId: 7 },
  { comune: "SASSINORO", zonaId: 4 },
  { comune: "SAVIANO", zonaId: 1 },
  { comune: "SAVIGNANO IRPINO", zonaId: 4 },
  { comune: "SCAFATI", zonaId: 3 },
  { comune: "SCALA", zonaId: 3 },
  { comune: "SCAMPITELLA", zonaId: 4 },
  { comune: "SCISCIANO", zonaId: 1 },
  { comune: "SENERCHIA", zonaId: 5 },
  { comune: "SERINO", zonaId: 3 },
  { comune: "SERRAMEZZANA", zonaId: 6 },
  { comune: "SERRARA FONTANA", zonaId: 1 },
  { comune: "SERRE", zonaId: 6 },
  { comune: "SESSA AURUNCA", zonaId: 1 },
  { comune: "SESSA CILENTO", zonaId: 6 },
  { comune: "SIANO", zonaId: 3 },
  { comune: "SICIGNANO DEGLI ALBURNI", zonaId: 7 },
  { comune: "SIRIGNANO", zonaId: 3 },
  { comune: "SOLOFRA", zonaId: 3 },
  { comune: "SOLOPACA", zonaId: 2 },
  { comune: "SOMMA VESUVIANA", zonaId: 1 },
  { comune: "SORBO SERPICO", zonaId: 3 },
  { comune: "SORRENTO", zonaId: 3 },
  { comune: "SPARANISE", zonaId: 1 },
  { comune: "SPERONE", zonaId: 3 },
  { comune: "STELLA CILENTO", zonaId: 6 },
  { comune: "STIO", zonaId: 6 },
  { comune: "STRIANO", zonaId: 3 },
  { comune: "STURNO", zonaId: 4 },
  { comune: "SUCCIVO", zonaId: 1 },
  { comune: "SUMMONTE", zonaId: 3 },
  { comune: "TAURANO", zonaId: 3 },
  { comune: "TAURASI", zonaId: 4 },
  { comune: "TEANO", zonaId: 1 },
  { comune: "TEGGIANO", zonaId: 7 },
  { comune: "TELESE", zonaId: 2 },
  { comune: "TEORA", zonaId: 4 },
  { comune: "TERZIGNO", zonaId: 1 },
  { comune: "TEVEROLA", zonaId: 1 },
  { comune: "TOCCO CAUDIO", zonaId: 2 },
  { comune: "TORA E PICCILLI", zonaId: 2 },
  { comune: "TORCHIARA", zonaId: 6 },
  { comune: "TORELLA DEI LOMBARDI", zonaId: 4 },
  { comune: "TORRACA", zonaId: 8 },
  { comune: "TORRE ANNUNZIATA", zonaId: 1 },
  { comune: "TORRE DEL GRECO", zonaId: 1 },
  { comune: "TORRE LE NOCELLE", zonaId: 4 },
  { comune: "TORRE ORSAIA", zonaId: 8 },
  { comune: "TORRECUSO", zonaId: 4 },
  { comune: "TORRIONI", zonaId: 4 },
  { comune: "TORTORELLA", zonaId: 8 },
  { comune: "TRAMONTI", zonaId: 3 },
  { comune: "TRECASE", zonaId: 1 },
  { comune: "TRENTINARA", zonaId: 6 },
  { comune: "TRENTOLA-DUCENTA", zonaId: 1 },
  { comune: "TREVICO", zonaId: 4 },
  { comune: "TUFINO", zonaId: 3 },
  { comune: "TUFO", zonaId: 4 },
  { comune: "VAIRANO PATENORA", zonaId: 2 },
  { comune: "VALLATA", zonaId: 4 },
  { comune: "VALLE AGRICOLA", zonaId: 2 },
  { comune: "VALLE DELL'ANGELO", zonaId: 6 },
  { comune: "VALLE DI MADDALONI", zonaId: 2 },
  { comune: "VALLESACCARDA", zonaId: 4 },
  { comune: "VALLO DELLA LUCANIA", zonaId: 6 },
  { comune: "VALVA", zonaId: 5 },
  { comune: "VENTICANO", zonaId: 4 },
  { comune: "VIBONATI", zonaId: 8 },
  { comune: "VICO EQUENSE", zonaId: 3 },
  { comune: "VIETRI SUL MARE", zonaId: 3 },
  { comune: "VILLA DI BRIANO", zonaId: 1 },
  { comune: "VILLA LITERNO", zonaId: 1 },
  { comune: "VILLAMAINA", zonaId: 4 },
  { comune: "VILLANOVA DEL BATTISTA", zonaId: 4 },
  { comune: "VILLARICCA", zonaId: 1 },
  { comune: "VISCIANO", zonaId: 3 },
  { comune: "VITULANO", zonaId: 2 },
  { comune: "VITULAZIO", zonaId: 1 },
  { comune: "VOLLA", zonaId: 1 },
  { comune: "VOLTURARA IRPINA", zonaId: 3 },
  { comune: "ZUNGOLI", zonaId: 4 },
];
